/** Dedicated public Knowledge Centre hostname (articles only). */
export const KNOWLEDGE_CENTRE_HOSTNAME = "knowledge.claritygroup.com.sg";

export function normalizeHostname(hostname: string): string {
  return hostname.trim().toLowerCase().split(":")[0] ?? "";
}

export function isKnowledgeCentreHostname(hostname: string): boolean {
  return normalizeHostname(hostname) === KNOWLEDGE_CENTRE_HOSTNAME;
}

/** User-facing paths allowed on the Knowledge Centre domain. */
export function isKnowledgeCentrePublicPath(pathname: string): boolean {
  const path = pathname.split("?")[0] ?? pathname;
  if (path === "/articles" || path.startsWith("/articles/")) return true;
  if (path === "/sitemap-articles.xml" || path === "/robots.txt") return true;
  return false;
}

/** Asset and API paths required for the public article SPA to function. */
export function isKnowledgeCentreInfrastructurePath(pathname: string): boolean {
  const path = pathname.split("?")[0] ?? pathname;
  if (path.startsWith("/assets/")) return true;
  if (path.startsWith("/api/trpc")) return true;
  if (path.startsWith("/api/digital-card-assets")) return true;
  if (path === "/favicon.ico" || path.startsWith("/favicon.")) return true;
  // Vite dev
  if (path.startsWith("/@vite") || path.startsWith("/@fs/") || path.startsWith("/src/")) return true;
  if (path.startsWith("/node_modules/")) return true;
  return false;
}

export function shouldBlockPathOnKnowledgeCentre(pathname: string): boolean {
  if (isKnowledgeCentreInfrastructurePath(pathname)) return false;
  if (pathname === "/" || pathname === "") return false;
  return !isKnowledgeCentrePublicPath(pathname);
}
